<template>
  <div>
    <v-collapse-wrapper :active="true">
      <div class="a-tab__title-block admin__a-tab admin__a-tab--modification-controls"
           v-collapse-toggle>
        <h3>{{$t('form.lot.reduction-results')}}</h3>
      </div>
      <div class="admin__a-tab-content admin__a-tab-content--show" v-collapse-content>
        <v-collapse-group class="a-ui-tab">
          <div class="a-ui-tab__block" v-for="(protocol, idx) in lot.reductionResult">
            <v-collapse-wrapper :active="true">
              <div class="a-ui-tab__control-panel">
                <div class="a-ui-tab__control" v-collapse-toggle>
                  <div class="a-ui-tab__arrow"></div>
                  <div class="a-ui-tab__number-block">{{idx + 1}}</div>
                  <div class="a-ui-tab__title">
                    {{$t(protocol.type.label)}}
                  </div>
                </div>
                <button class="gui-btn gui-btn--red gui-btn--w-260" type="button" v-if="protocol.permissions.CAN_DOWNLOAD_PROTOCOL" @click="onExportProtocolClick(protocol)">{{$t('buttons.create-reduction-protocol')}}</button>
              </div>
              <div class="a-ui-tab__content-block" v-collapse-content>
                <div class="a-ui-tab__content">
                  <p class="a-label a-label--auto" v-if="!protocol.hasFile && !protocol.permissions.CAN_UPLOAD_PROTOCOL">{{$t('labels.no-reduction-results')}}</p>
                  <template v-else>
                    <div class="a-ui-tab__file-flex-block" v-for="file in protocol.files">
                      <div class="a-ui-tab__file-item-left">
                        <div class="a-ui-tab__file-block-number" v-if="file.hasFile">
                          {{file.version}}
                        </div>

                        <file-link :name="$t('form.lot.reduction-result')"
                                   :link="externalLink(file.uid)"
                                   :signed="file.hasSign"
                                   @onsigncheck="onFileSignCheckClick(file.version)"
                                   v-if="file.hasFile">
                          <div class="input-file__actual-block">
                            <div class="input-file__actual-img input-file__hidden">
                              <img src="@/assets/img/static/clientarea-details.svg" alt="">
                            </div>
                            <div class="input-file__actual" v-if="file.isActual">{{$t('form.lot.actual-file-version')}}</div>
                            <div class="input-file__not-actual" v-else>{{$t('form.lot.legacy-file-version')}}</div>
                          </div>
                        </file-link>

                        <template v-if="!file.hasFile && protocol.permissions.CAN_UPLOAD_PROTOCOL">
                          <file-picker :label="$t('buttons.attach-file')"
                                       :signing="lot.permissions.SHOULD_BE_SIGNED"
                                       @prepared="onFileReady($event, { type: protocol.type.valueOf() })">
                          </file-picker>
                        </template>
                    </div>

                    <div class="a-ui-tab__file-item-right" v-if="file.hasFile && file.permissions.CAN_RECOVERY_PROTOCOL">
                      <button class="gui-btn gui-btn--red gui-btn--w-160" v-if="!file.isActual" type="button" @click="onRestoreFileClick(({type: protocol.type.valueOf(), version: file.version}))">{{$t('buttons.restore-file')}}</button>
                    </div>
                  </div>
                  </template>
                </div>
              </div>
            </v-collapse-wrapper>
          </div>
        </v-collapse-group>
      </div>

      <signature-details-dialog ref="signCheck"></signature-details-dialog>
      <confirmation-dialog ref="confirmation" @confirm="onConfirm" @cancel="$refs.confirmation.close()"></confirmation-dialog>
    </v-collapse-wrapper>
  </div>
</template>

<script>
  import SignatureDetailsDialog from '@/components/common/dialogs/SignatureDetailsDialog'
  import ConfirmationDialog from '@/components/common/dialogs/ConfirmationDialog'
  import Errors from '@/api/types/errors'

  export default {
    props: {
      lot: Object
    },

    data: () => ({
      protocol: undefined
    }),

    components: {
      ConfirmationDialog,
      SignatureDetailsDialog
    },

    methods: {
      async onFileReady(file, { type }) {
        if (file instanceof File) {
          file = {
            file,
            sign: undefined
          }
        }

        this.runBlockerAction(async () => {
          try {
            await this.$store.dispatch('addFileToProtocol', {
              lotId: this.lot.id,
              protocolType: type,
              file: file.file,
              sign: file.sign
            });
          }
          catch(e) {
            console.error('failed attaching file to protocol', e);
            this.globalErrorHandler(e, {
              'BAD_SIGNATURE': 'errors.public-lot.attaching-file-to-protocol.bad-signature'
            }, 'errors.public-lot.attaching-file-to-protocol.unknown');
          }
        })
      },

      async onRestoreFileClick({type, version}) {
        this.runBlockerAction(async () => {
          try {
            await this.$store.dispatch('restoreFileInProtocol', {
              lotId: this.lot.id,
              protocolType: type,
              version: version
            });
          }
          catch(e) {
            console.error('failed restoring file in protocol', e);
            this.globalErrorHandler(e);
          }
        })
      },

      async onExportProtocolClick({ type }) {
        this.protocol = type.valueOf();
        await this.onDownloadResultClick();
      },

      async onDownloadResultClick() {
        this.runBlockerAction(async () => {
          try {
            await this.$store.dispatch('downloadReport', {
              lotId: this.lot.id,
              protocolType: this.protocol,
              report: { members: [] }
            });
          }
          catch(e) {
            console.error('failed download protocol', e);
            this.globalErrorHandler(e);
          }
        })
      },

      async onFileSignCheckClick(version) {
        this.runAction(async () => {
          try {
            const signature = await this.$store.dispatch('checkProtocolFileSignature', {
              lotId: this.lot.id,
              type: this.protocol.type,
              version: version
            });

            this.$refs.signCheck.open(signature);
          }
          catch(e) {
            console.error('failed checking file signature', e);
            this.globalErrorHandler(e);
          }
        })
      },

      onUploadTo1CClick(){
        this.$refs.confirmation.open({
          title: 'dialogs.upload-to-1c.title',
          text: 'dialogs.upload-to-1c.body'
        });
      },

      async onConfirm() {
        this.runBlockerAction(async () => {
          try {
            await this.$store.dispatch('uploadTo1C', {
              lotId: this.lot.id
            });
            this.$refs.confirmation.close();
          }
          catch(e) {
            console.error('unable to upload tender to 1C', e);
            this.globalErrorHandler(e);
          }
        })
      },
    }
  }
</script>

<style scoped>

</style>
